const login = () => import('@/page/login/login')
const register = () => import('@/page/login/register')
const forgetpwd = () => import('@/page/login/forgetpwd')
const checkphone = () => import('@/page/login/checkphone')
const bindphone = () => import('@/page/login/bindphone')
const mediate = () => import('@/page/login/mediate')
const appeal = () => import('@/page/login/appeal')
// const registercard = () => import('@/page/login/registercard')
const loginRouter = [{
    path: '/login',
    name: 'login',
    component: login
}, {
    path: '/register',
    name: 'register',
    component: register
}, {
    path: '/forgetpwd',
    name: 'forgetpwd',
    component: forgetpwd
}, {
    path: '/bindphone',
    name: 'bindphone',
    component: bindphone
}, {
    path: '/checkphone',
    name: 'checkphone',
    component: checkphone
}, 
{
    path: '/mediate',
    name: 'mediate',
    component: mediate
}, {
    path: '/appeal',
    name: 'appeal',
    component: appeal
}, 
// {
//     path: '/registercard',
//     name: 'registercard',
//     component: registercard
// }
]
export default loginRouter



// WEBPACK FOOTER //
// ./src/router/login.js